import _ from 'lodash';
import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../common/Navbar";
import StatusTemplate from "../common/StatusTemplate";
import { BASE_IMG } from '../../constants';

const CTA_TEMPLATES = {
  verification_success: {
    title: "Email Verified Successfully",
    subText: [
      "Thank you, your email has been verified.",
      "Your account is now active. Please login to continue.",
    ],
  
    supportRequestLink: "",
    supportText: "",
    buttonLink: "/login",
    buttonText: "Login Now",
    imageSrc: `${BASE_IMG}/success.svg`,
    imageAlt: 'Email verified illustration',
  },
  generic_success: {
    title: "Completed Successfully",
    subText: [
      "Thank you, your request has been completed successfully",
      "Your are good to go, Please login to continue or ",
    ],
  
    supportRequestLink: "mailto:info@raze.co.in",
    supportText: "submit a request",
    buttonLink: "/login",
    buttonText: "Login Now",
    imageSrc: `${BASE_IMG}/success.svg`,
    imageAlt: 'Success illustration',
  },
  login_failure: {
    title: "Aaah! Something went wrong",
    subText: [
      "Brace yourself till we get the error fixed, You may also refresh the page or try again later. If you continue",
      "to see this error, raise a",
    ],
  
    supportRequestLink: "mailto:info@raze.co.in",
    supportText: "support request",
    buttonLink: "/login",
    buttonText: "Login Now",
    imageSrc: `${BASE_IMG}/failure.svg`,
    imageAlt: 'Login failure illustration',
  },
  generic_failure: {
    title: "Aaah! Something went wrong",
    subText: [
      "Brace yourself till we get the error fixed, You may also refresh the page or try again later. If you continue",
      "to see this error, raise a",
    ],
  
    supportRequestLink: "mailto:info@raze.co.in",
    supportText: "support request",
    buttonLink: "/login",
    buttonText: "Go To Login",
    imageSrc: `${BASE_IMG}/failure.svg`,
  },
  grant_access_failure:{
    title: "Trouble Granting Access!",
    subText: [
      "Could not grant access to your google drive. Please try again. If you continue to see this error, raise a ",
    ],
  
    supportRequestLink: "mailto:info@raze.co.in",
    supportText: "support request",
    buttonLink: () => { window.close(); }, 
    buttonText: "Try Again",
    imageSrc: `${BASE_IMG}/failure.svg`,
  },

  grant_access_success:{
    title: "Access Granted Successfully",
    subText: [
      "You have successfully granted access to your google drive. Now you can upload and save attachments directly in your drive",
    ],
  
    supportRequestLink: "",
    supportText: "",
    buttonLink: () => { window.close(); }, 
    buttonText: "Close",
    imageSrc: `${BASE_IMG}/success.svg`,
  }
}

export default function StatusPage({mode}) {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  if(!mode) return <></>
  const type = queryParams.get("type");

  return (
    <>
      <Navbar/>
      {mode === "success" && type === "email" && <StatusTemplate data={CTA_TEMPLATES['verification_success']} />}
      {mode === "success" && type === "gdrive" && <StatusTemplate data={CTA_TEMPLATES['grant_access_success']} />}
      {mode === "success" && !type && <StatusTemplate data={CTA_TEMPLATES['generic_success']} />}
      {mode === "failure" && type === "login" && <StatusTemplate data={CTA_TEMPLATES['login_failure']} />}
      {mode === "failure" && type === "gdrive" && <StatusTemplate data={CTA_TEMPLATES['grant_access_failure']} />}
      {mode === "failure" && !type && <StatusTemplate data={CTA_TEMPLATES['generic_failure']} />}
      <p style={{textAlign: 'center', marginTop: '20px'}}>&copy; Copyright 2026 RazeHQ. All rights reserved.</p>
    </>
  );
}
